import { Col, Icon, Row } from "antd";
import React  from "react";
import I18n from "../../common/I18n";
import BaseList from "../BaseList";
import EditIcon from "../common/EditIcon";
import CustomerOrderDetails from "./CustomerOrderDetails";
import Copyable from "../common/Copyable";
export default class ClonedOrderList extends BaseList {
  constructor(props) {
    super(props);
    const { importLabel } = this.props;
    this.state = { loadingOrderId: null };
    this.columns = [
      {
        title: "#",
        key: "index",
        align: "center",
        render: (text, record, index) => index + 1,
      },
      {
        title: importLabel?.source || `${I18n.t("general.source")} ${I18n.t("general.order_number")}`,
        dataIndex: "source_order_number",
        key: "source_order_number",
        render: (data, record) => {
          return this.renderEditableOrder(record.source_order_id, record.source_order_number);
        },
      },
      {
        title: importLabel?.cloned || `${I18n.t("order.cloned_order")}`,
        dataIndex: "cloned_order_no",
        key: "cloned_order_no",
        render: (data, record) => {
          return this.renderEditableOrder(record.cloned_order_id, record.cloned_order_no);
        },
      }
    ];
  }

  handleEditOrder = async (orderId) => {
    this.setState({ loadingOrderId: orderId });
    const result = this.props.handleEditOrder(orderId);
    if (result && typeof result.then === "function") {
      try {
        await result;
      } finally {
        this.setState({ loadingOrderId: null });
      }
    }
  };

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.data || prevProps.data.length > 0) &&
      (!this.props.data || this.props.data.length === 0)
    ) {
      this.setState({ loadingOrderId: null });
    }
  }

  componentWillUnmount() {
    this.setState({ loadingOrderId: null });
  }

  renderEditableOrder = (orderId ,orderNumber ) => {
    const { loadingOrderId } = this.state;
    const loading = loadingOrderId === orderId;
    return (
      <Row type="flex" gutter={4}>
        <Col>
          { orderNumber }
        </Col>
        <Col>
          <EditIcon loading={loading} handleClick={() => this.handleEditOrder(orderId)}/>
        </Col>
        <Col>
          <Copyable text={orderNumber} />
        </Col>
      </Row>
    );
  }

}
